import { Injectable } from "@angular/core";
import { IdentityModule, AuthorizeRequest, AuthorizeResponse } from '@grabjs/superapp-sdk';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from "../../share/service/alert.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})

export class AuthenticateGrabIDClientService {
  identityModule: any = new IdentityModule();

  private clientId: string = `${environment.grabMiniApp.clientId}`;
  private redirectUri: string = `${environment.grabMiniApp.redirectUri}`;
  private env: string = `${environment.grabMiniApp.env}`;

  constructor(
    private alertService: AlertService,
    private route: ActivatedRoute
  ) {
  }

  async startAuthentication(): Promise<AuthorizeResponse> {
    const request: AuthorizeRequest = {
      clientId: this.clientId,
      environment: this.env,
      redirectUri: this.redirectUri,
      responseMode: 'in_place',
      scope: [
        'mobile.checkout',
      ].join(' ')
    };

    try {
      return await this.identityModule.authorize(request);
    } catch (error) {
      this.alertService.openSnackBar("Grab OAuth: startAuthentication error");
    }
  }

  handleAuthenticateOAuthCallback(): {
    code: string;
  } {
    try {
      const code = this.route.snapshot.queryParamMap.get('code');

      if (!code) {
        throw new Error("Missing authorization code");
      }

      return {
        code,
      };
    } catch (error) {
      this.alertService.openSnackBar('Grab OAuth Callback:', error);
      throw error;
    }
  }
}
